import { apiSlice } from '../../api/apiSlice';
import { GET_COACHING_DUE_TODOS } from '../../constants';

export const homePageSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getDueToDos: builder.query({
            query: (data: any) => ({
                url: GET_COACHING_DUE_TODOS,
                method: 'GET',
                params: data,
            }),
        }),
    }),
});

export const { useGetDueToDosQuery} =
homePageSlice;
